module.exports = __webpack_public_path__ + "img/laboratorio4_4-3_682.edf7fe9f.webp";